import React, { createContext, useContext, useEffect, useState } from "react";
import manifest from "./assets3d.manifest.json";
import { loadPhotoMaps } from "./rigMaterials";

/** Vendored CC0 asset manifest (HDRI skies, PBR textures, props) – see scripts/vendor_polyhaven.py. */
export const assets = manifest;

const PhotoMapsContext = createContext(null);
export const usePhotoMaps = () => useContext(PhotoMapsContext);

/** Provides the photo texture set once all maps are loaded (null before that → procedural fallbacks). Mount inside <Canvas>. */
export function PhotoMapsProvider({ children }) {
  const [maps, setMaps] = useState(null);
  useEffect(() => {
    let on = true;
    loadPhotoMaps(manifest).then((m) => { if (on) setMaps(m); });
    return () => { on = false; };
  }, []);
  return <PhotoMapsContext.Provider value={maps}>{children}</PhotoMapsContext.Provider>;
}
